class AbstractManager {
  /**
   * Base instance.
   */
  __base;
  /**
   * Get the base instance root element.
   */
  get __element() {
    return this.__base.$el;
  }
  /**
   * Get the base instance config.
   */
  get __config() {
    return this.__base.__config;
  }
  /**
   * Get the events manager.
   */
  get __eventsManager() {
    return this.__base.__events;
  }
  __props = {};
  get props() {
    return this.__props;
  }
  /**
   * Class constructor.
   */
  constructor(base) {
    this.__base = base;
  }
}
export {
  AbstractManager
};
//# sourceMappingURL=AbstractManager.js.map
